"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDark = exports.isLight = exports.getName = exports.getValue = void 0;

const types_1 = require("./types");

function getValue(color) {
  return Math.round(0.299 * color[0] + 0.587 * color[1] + 0.114 * color[2]);
}

exports.getValue = getValue;

function getName(color) {
  return getValue(color) > 170 ? types_1.BeethovenLuminance.light : types_1.BeethovenLuminance.dark;
}

exports.getName = getName;

function isLight(color) {
  return getName(color) == types_1.BeethovenLuminance.light;
}

exports.isLight = isLight;

function isDark(color) {
  return getName(color) == types_1.BeethovenLuminance.dark;
}

exports.isDark = isDark;